/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';

export const NotInPrimitiveString: core.serialization.ObjectSchema<
    serializers.NotInPrimitiveString.Raw,
    Truvity.NotInPrimitiveString
> = core.serialization.object({
    values: core.serialization.list(core.serialization.string()),
});

export declare namespace NotInPrimitiveString {
    export interface Raw {
        values: string[];
    }
}
